// export const BASE_URL = 'https://api.partyridellc.com/api/'; //PROD
// export const BASE_URL = 'https://dev.partyridellc.com/api/'; //DEV
export const BASE_URL = 'https://devqsoftbe.onrender.com/api/'; //LOCAL
export const SOCKET_URL = 'http://192.168.29.50:8000';

export const API_END_POINTS =  {

  // ================= USER AUTH =================

  userSendSignup: {
    END_POINT: 'user/signup',
    TYPE: 'POST',
    KEY: 'userSendSignup',
  },

  userSendLogin: {
    END_POINT: 'user/login',
    TYPE: 'POST',
    KEY: 'userSendLogin',
  },

  userVerifyOtp: {
    END_POINT: 'user/verify-otp',
    TYPE: 'POST',
    KEY: 'userVerifyOtp',
  },

  userLogout: {
    END_POINT: 'user/logout',
    TYPE: 'POST',
    KEY: 'userLogout',
  },

  userRefreshToken: {
    END_POINT: 'user/refresh-token',
    TYPE: 'POST',
    KEY: 'userRefreshToken',
  },

  userGetMe: {
    END_POINT: 'user/me',
    TYPE: 'GET',
    KEY: 'userGetMe',
  },

 trackUserRoute: {
  END_POINT: "user/track-route",
  TYPE: "POST",
  KEY: "trackUserRoute",
},



  // ================= SUBJECT =================

  createSubject: {
    END_POINT: 'admin/subjects',
    TYPE: 'POST',
    KEY: 'createSubject',
  },

  updateSubject: {
    END_POINT: 'admin/subjects/:id',
    TYPE: 'PUT',
    KEY: 'updateSubject',
  },

  deleteSubject: {
    END_POINT: 'admin/subjects/:id',
    TYPE: 'DELETE',
    KEY: 'deleteSubject',
  },

  getAllSubjects: {
    END_POINT: 'user/subjects',
    TYPE: 'GET',
    KEY: 'getAllSubjects',
  },

  // getSubjectById: {
  //   END_POINT: 'user/subjects/:id',
  //   TYPE: 'GET',
  //   KEY: 'getSubjectById',
  // },
  getTopicsBySubjectId : {
    END_POINT: 'user/subjects/:id/topics',
    TYPE: 'GET',
    KEY: 'getTopicsBySubjectId',
  },


  // ================= TOPIC =================

  createTopic: {
    END_POINT: 'admin/topics',
    TYPE: 'POST',
    KEY: 'createTopic',
  },

  updateTopic: {
    END_POINT: 'admin/topics/:id',
    TYPE: 'PUT',
    KEY: 'updateTopic',
  },

  deleteTopic: {
    END_POINT: 'admin/topics/:id',
    TYPE: 'DELETE',
    KEY: 'deleteTopic',
  },

  getAllTopics: {
    END_POINT: 'user/topics',
    TYPE: 'GET',
    KEY: 'getAllTopics',
  },

  getTopicById: {
    END_POINT: 'user/topics/:id',
    TYPE: 'GET',
    KEY: 'getTopicById',
  },


  // ================= CONTENT =================

  createContent: {
    END_POINT: 'admin/content',
    TYPE: 'POST',
    KEY: 'createContent',
  },

  updateContent: {
    END_POINT: 'admin/content/:id',
    TYPE: 'PUT',
    KEY: 'updateContent',
  },

  deleteContent: {
    END_POINT: 'admin/content/:id',
    TYPE: 'DELETE',
    KEY: 'deleteContent',
  },

  getAllContent: {
    END_POINT: 'user/content',
    TYPE: 'GET',
    KEY: 'getAllContent',
  },

  getContentById: {
    END_POINT: 'user/content/:id',
    TYPE: 'GET',
    KEY: 'getContentById',
  },


  // ================= QUESTIONS =================

  addQuestion: {
    END_POINT: 'admin/questions',
    TYPE: 'POST',
    KEY: 'addQuestion',
  },

  updateQuestion: {
    END_POINT: 'admin/questions/:id',
    TYPE: 'PUT',
    KEY: 'updateQuestion',
  },

  deleteQuestion: {
    END_POINT: 'admin/questions/:id',
    TYPE: 'DELETE',
    KEY: 'deleteQuestion',
  },

  getAllQuestions: {
    END_POINT: 'user/questions',
    TYPE: 'GET',
    KEY: 'getAllQuestions',
  },

  getQuestionById: {
    END_POINT: 'user/questions/:id',
    TYPE: 'GET',
    KEY: 'getQuestionById',
  },


  // ================= TEST =================

  createTest: {
    END_POINT: 'admin/test',
    TYPE: 'POST',
    KEY: 'createTest',
  },

  getAllTests: {
    END_POINT: 'user/test',
    TYPE: 'GET',
    KEY: 'getAllTests',
  },

  getTestById: {
    END_POINT: 'user/test/:id',
    TYPE: 'GET',
    KEY: 'getTestById',
  },

  startTest: {
    END_POINT: 'user/test/start',
    TYPE: 'POST',
    KEY: 'startTest',
  },

  saveAnswer: {
    END_POINT: 'user/test/save-answer',
    TYPE: 'POST',
    KEY: 'saveAnswer',
  },

  submitTest: {
    END_POINT: 'user/test/submit',
    TYPE: 'POST',
    KEY: 'submitTest',
  },

  leaderboard: {
    END_POINT: 'user/test/leaderboard/:testId',
    TYPE: 'GET',
    KEY: 'leaderboard',
  },

  myAttempts: {
    END_POINT: 'user/test/my-attempts',
    TYPE: 'GET',
    KEY: 'myAttempts',
  },


  // ================= PREVIOUS YEAR QUESTIONS =================
  getAllPYQ:{
    END_POINT: 'user/pyq',
    TYPE: 'GET',
    KEY: 'getAllPYQ',
  },

};